module.exports = __webpack_public_path__ + "static/media/recursive-MONO_CASL_wght_slnt_ital--2019_11_05-00_13.975cad7e.ttf";